export type Gender = 'Male' | 'Female' | 'Other' | '';

export const GENDER_OPTIONS: Exclude<Gender, ''>[] = ['Male', 'Female', 'Other'];

export interface Student {
  id: string;
  ownerId: string;
  fullNames: string;
  gender: Gender;
  className: string;
  fatherName: string;
  fatherPhone: string;
  motherName: string;
  motherPhone: string;
  note: string;
  photoURL: string;
  photoPath: string;
  createdAtMs: number;
  updatedAtMs: number;
}

/** Everything a user can type into the Add / Edit Student form. */
export interface StudentFormValues {
  fullNames: string;
  gender: Gender;
  className: string;
  fatherName: string;
  fatherPhone: string;
  motherName: string;
  motherPhone: string;
  note: string;
}

export const emptyStudentForm: StudentFormValues = {
  fullNames: '',
  gender: '',
  className: '',
  fatherName: '',
  fatherPhone: '',
  motherName: '',
  motherPhone: '',
  note: ''
};

export type SortKey = 'newest' | 'oldest' | 'name-asc' | 'name-desc' | 'class-asc';

export interface ExportOptions {
  scope: 'all' | 'class' | 'gender';
  className: string;
  gender: Exclude<Gender, ''> | '';
}
